'use client'

import {
  AspectRatio,
  Box,
  Button,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react'
import React, { Ref } from 'react'
import { ClearIcon, RightIcon } from '@/_assets/icon-components'

interface IProps {
  color?: string
  isError?: boolean
  label?: string
  value?: string | number | null
  leftIcon?: React.ReactElement
  reverseY?: boolean
  isClear?: boolean
  onClick?: () => void
  onClear?: () => void
  ref?: Ref<HTMLButtonElement>
  isPaymentIntegrations?: string
}

export default function DetailButton({
  label,
  value,
  reverseY,
  leftIcon,
  color = '#000000',
  isError = false,
  onClear = () => {},
  onClick = () => {},
  isClear = false,
  ref,
  isPaymentIntegrations,
}: IProps) {
  return (
    <Button
      ref={ref}
      p={4}
      h='fit'
      w='full'
      rounded='none'
      whiteSpace='normal'
      textAlign='left'
      variant='ghost'
      border='none'
      _hover={{
        bg: 'background',
      }}
      onClick={() => {
        !isClear && onClick()
      }}
    >
      <HStack gap={4} flex={1} h={6}>
        {leftIcon && isPaymentIntegrations === 'gpay' ? (
          leftIcon
        ) : (
          <AspectRatio minW={6}>{leftIcon}</AspectRatio>
        )}
        <VStack
          align='flex-start'
          justify='center'
          gap={1.5}
          flexDir={reverseY ? 'column-reverse' : 'column'}
        >
          {label && (
            <Text
              fontSize={value ? 'xs' : 'sm'}
              fontWeight='400'
              color={isError ? 'red' : color}
              lineHeight={1}
            >
              {label}
            </Text>
          )}
          {value && (
            <Text
              color={color}
              fontSize='sm'
              lineClamp={2}
              fontWeight='500'
              lineHeight={1.2}
            >
              {value}
            </Text>
          )}
        </VStack>
      </HStack>
      {isClear ? (
        <Box onClick={onClear} p={0}>
          <ClearIcon />
        </Box>
      ) : (
        <AspectRatio ratio={1 / 1} minW={4}>
          <RightIcon
            width='16'
            height='16'
            color={isError ? 'red' : '#000000'}
          />
        </AspectRatio>
      )}
    </Button>
  )
}
